import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApiService from "@/api/ApiService";
Vue.use(VueAxios, axios)
export const ActivitiesAgendaService = {

  baseURL: process.env.VUE_APP_ACTIVITIES_AGENDA_URL,

  getBookingTypes() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/bookings/types`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getPaymentTypes() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/bookings/payments/types`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  createEvent(params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v1/bookings`, params)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  updateEvent(eventId, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/bookings/${eventId}`, params)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  destroy(eventId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/v1/bookings/${eventId}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  approve(eventId, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/bookings/approval/${eventId}`, params)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getAllBookingStatuses() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/bookings-status`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  createNewPursue(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v1/pursues`, data)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  deletePursue(pursueId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/v1/pursues/${pursueId}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }

}


